module.exports = __webpack_public_path__ + "static/media/KateKirwin.d515d742.jpg";